/**
 * Fusión de la config que devuelve Oracle con lo que ya cargó el usuario.
 *
 * Lo usan tanto el alta de organizaciones (modal) como `/empresas/:id`.
 */

export interface ResumenOracle {
  /** Campos que estaban vacíos y Oracle completó. */
  aplicados: string[];
  /** Campos donde Oracle dice otra cosa y se conservó lo cargado a mano. */
  distintos: string[];
  /** De dónde salió cada valor inferido de las altas previas (respaldo). */
  procedencia: string[];
}

export function resumenVacio(): ResumenOracle {
  return { aplicados: [], distintos: [], procedencia: [] };
}

/**
 * Decide con qué valor queda un campo al traer la config de Oracle.
 *
 * Regla: Oracle completa lo que está vacío, pero NUNCA pisa lo que el usuario
 * cargó a mano. Antes eso pasaba en silencio (`p.cuit || cfg.cuit`) y se leía
 * como "no me trajo nada"; ahora cada caso se reporta —qué se completó y en qué
 * campo Oracle dice otra cosa— para que corregir sea decisión del usuario.
 *
 * `reportarDistinto` en false sirve para el campo que se completa con el mismo
 * dato de Oracle que otro (nombre comercial ← NOMBRE) y no debe repetir el aviso.
 */
export function fusionar(
  label: string,
  actual: string | null | undefined,
  deOracle: string | null | undefined,
  resumen: ResumenOracle,
  reportarDistinto = true,
): string {
  const oracle = (deOracle ?? '').trim();
  const mio = (actual ?? '').trim();
  if (!oracle) return mio;
  if (!mio) {
    resumen.aplicados.push(`${label}: ${oracle}`);
    return oracle;
  }
  if (mio !== oracle && reportarDistinto) {
    resumen.distintos.push(`${label}: Oracle dice «${oracle}» — se mantuvo «${mio}»`);
  }
  return mio;
}
